import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { update } from './faseActions';
import Select from '../common/form/select';

import ReactTableGT2A from '../common/grid/gridReactTable';
import SPButton from '../common/form/spButton';
import Button from '../common/form/button';
import { Modal } from 'react-bootstrap';
import MapaFase from './mapaFase';
import PermissaoUsuario from '../auth/permissao';
import DivEditableGridNumeric from '../common/grid/divEditableGridNumeric';

const INTENSIDADE_TRAFEGO_OPCOES = [
  {
    value: '1.3',
    label: 'Moderado — 30% mais lento que o normal',
    shortLabel: 'Moderado',
    hint: '30% mais lento que o normal',
    mapsColor: '#FBBC04',
  },
  {
    value: '1.5',
    label: 'Intenso — 50% mais lento que o normal',
    shortLabel: 'Intenso',
    hint: '50% mais lento que o normal',
    mapsColor: '#EA4335',
  },
  {
    value: '1.8',
    label: 'Muito intenso — 80% mais lento que o normal',
    shortLabel: 'Muito intenso',
    hint: '80% mais lento que o normal',
    mapsColor: '#7B1E1E',
  },
];

class FaseList extends Component {
  constructor() {
    super();

    this.renderEditableAusencia = this.renderEditableAusencia.bind(this);
    this.renderEditablePiscante = this.renderEditablePiscante.bind(this);
    this.renderEditablePiscantePedestre = this.renderEditablePiscantePedestre.bind(this);
    this.renderEditableTipo = this.renderEditableTipo.bind(this);
    this.renderButtonMap = this.renderButtonMap.bind(this);
    this.renderEditableQuantidade = this.renderEditableQuantidade.bind(this);
    this.renderEditableMinimo = this.renderEditableMinimo.bind(this);
    this.renderAcoes = this.renderAcoes.bind(this);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.clickOk = this.clickOk.bind(this);
    this.handleShowDescricao = this.handleShowDescricao.bind(this);
    this.handleCloseDescricao = this.handleCloseDescricao.bind(this);
    this.handleSaveDescricao = this.handleSaveDescricao.bind(this);
    this.handleShowTrafego = this.handleShowTrafego.bind(this);
    this.handleCloseTrafego = this.handleCloseTrafego.bind(this);
    this.handleSaveTrafego = this.handleSaveTrafego.bind(this);

    this.clickMapaFase = this.clickMapaFase.bind(this);
    this.onChangeSelect = this.onChangeSelect.bind(this);
    this.onChangeTipo = this.onChangeTipo.bind(this);

    this.mapaFaseRef = React.createRef();

    this.state = {
      show: false,
      html: '',
      idx: null,
      controladorTitle: '',
      fases: [],
      showDescricao: false,
      descricaoIdx: null,
      descricaoTexto: '',
      showTrafego: false,
      trafegoIdx: null,
      trafegoMonitora: false,
      trafegoDistancia: 50,
      trafegoIntensidade: '1.5',
    };
  }

  normalizarRatioLimiar(valor) {
    const n = parseFloat(valor);
    if (Number.isNaN(n)) return 1.5;
    return Math.min(2.5, Math.max(1.1, Math.round(n * 100) / 100));
  }

  labelIntensidade(ratio) {
    const n = this.normalizarRatioLimiar(ratio);
    if (n >= 1.8) return 'Muito intenso';
    if (n >= 1.5) return 'Intenso';
    return 'Moderado';
  }

  resumoTrafego(fase) {
    if (!fase || Number(fase.monitora_trafego) !== 1) return 'Configurar alertas de tráfego';
    const dist = fase.distancia_trecho_m != null ? fase.distancia_trecho_m : 50;
    return `Tráfego ativo — ${dist} m, ${this.labelIntensidade(fase.ratio_limiar)}`;
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow(row, cellInfo) {
    this.setState({
      html: (
        <MapaFase
          data-contId={row.controlador_id}
          data-faseId={row.id}
          data-latitude={row.latitude}
          data-longitude={row.longitude}
          latitude={row.latitude}
          longitude={row.longitude}
          data-fases={this.state.fases}
        />
      ),
    });

    this.setState({ show: true });
  }

  clickOk(cellInfo) {
    // Usa this.state.fases que é mantido em sincronia via callback onFasesChange do MapaFase
    const fasesAtualizadas = this.state.fases;

    // Atualiza o state local se veio algo válido
    if (Array.isArray(fasesAtualizadas)) {
      this.setState({ fases: fasesAtualizadas });

      // Propaga para o controladorForm para que o Salvar geral também tenha os dados atualizados
      if (this.props.onFasesChange) this.props.onFasesChange(fasesAtualizadas);

      // Salva item específico quando índice é válido
      const idx = this.state.idx;
      if (idx !== null && idx >= 0 && idx < fasesAtualizadas.length) {
        const faseAtualizada = fasesAtualizadas[idx];
        if (faseAtualizada) {
          // Corrige controlador_id se for 0, usando o ID das props
          const controladorIdCorreto =
            faseAtualizada.controlador_id === 0 || !faseAtualizada.controlador_id
              ? this.props['data-id']
              : faseAtualizada.controlador_id;

          const faseCorrigida = {
            ...faseAtualizada,
            controlador_id: controladorIdCorreto,
          };

          const idOk = faseCorrigida.id != null && faseCorrigida.id !== '';
          const contOk = controladorIdCorreto != null && controladorIdCorreto !== '' && controladorIdCorreto !== 0;

          console.log(
            '[DEBUG clickOk] idOk:',
            idOk,
            'contOk:',
            contOk,
            'controladorIdCorreto:',
            controladorIdCorreto,
            'setas:',
            faseCorrigida.setas,
          );
          if (idOk && contOk) {
            this.props.update(faseCorrigida);
          } else {
            console.log('[DEBUG clickOk] UPDATE NÃO CHAMADO! id:', faseCorrigida.id, 'contId:', controladorIdCorreto);
          }
        }
      }
    }

    this.setState({ show: false });
  }

  clickMapaFase(cellInfo) {
    const data = this.state.fases;
    const fase = data[cellInfo.index];

    // Usa coordenadas da fase se existirem e forem válidas, senão usa do controlador
    const hasValidFaseCoords =
      Number.isFinite(fase.latitude) &&
      Number.isFinite(fase.longitude) &&
      !(fase.latitude === 0 && fase.longitude === 0);
    const finalLat = hasValidFaseCoords ? fase.latitude : this.props['data-controlador-lat'] || -27.21;
    const finalLng = hasValidFaseCoords ? fase.longitude : this.props['data-controlador-lng'] || -49.64;

    this.setState({
      html: (
        <MapaFase
          ref={this.mapaFaseRef}
          data-contId={fase.controlador_id}
          data-faseId={fase.id}
          data-latitude={fase.latitude}
          data-longitude={fase.longitude}
          data-idx={cellInfo.index}
          latitude={finalLat}
          longitude={finalLng}
          data-fases={this.state.fases}
          onFasesChange={fases => this.setState({ fases })}
        />
      ),
    });
    this.setState({ idx: cellInfo.index });

    this.setState({
      controladorTitle: `- Controlador ${data[cellInfo.index].controlador_id} - Fase ${data[cellInfo.index].id}`,
    });

    this.setState({ show: true });
  }

  handleShowDescricao(cellInfo) {
    const fase = this.state.fases[cellInfo.index];
    this.setState({
      showDescricao: true,
      descricaoIdx: cellInfo.index,
      descricaoTexto: fase.descricao || '',
    });
  }

  handleCloseDescricao() {
    this.setState({ showDescricao: false });
  }

  handleSaveDescricao() {
    const { descricaoIdx, descricaoTexto } = this.state;
    if (descricaoIdx === null) return;

    const data = this.state.fases.slice();
    data[descricaoIdx] = { ...data[descricaoIdx], descricao: descricaoTexto };
    this.setState({ fases: data, showDescricao: false });

    if (this.props.onFasesChange) this.props.onFasesChange(data);

    const fase = data[descricaoIdx];
    const controladorIdCorreto =
      fase.controlador_id === 0 || !fase.controlador_id ? this.props['data-id'] : fase.controlador_id;
    if (fase.id && controladorIdCorreto) {
      this.props.update({ ...fase, controlador_id: controladorIdCorreto });
    }
  }

  handleShowTrafego(cellInfo) {
    const fase = this.state.fases[cellInfo.index];
    const ratio = this.normalizarRatioLimiar(fase.ratio_limiar);
    const ratioStr = INTENSIDADE_TRAFEGO_OPCOES.find(o => parseFloat(o.value) === ratio)
      ? String(ratio)
      : ratio >= 1.8
      ? '1.8'
      : ratio >= 1.5
      ? '1.5'
      : '1.3';
    this.setState({
      showTrafego: true,
      trafegoIdx: cellInfo.index,
      trafegoMonitora: Number(fase.monitora_trafego) === 1,
      trafegoDistancia: fase.distancia_trecho_m != null ? Number(fase.distancia_trecho_m) : 50,
      trafegoIntensidade: ratioStr,
    });
  }

  handleCloseTrafego() {
    this.setState({ showTrafego: false });
  }

  handleSaveTrafego() {
    const { trafegoIdx, trafegoMonitora, trafegoDistancia, trafegoIntensidade } = this.state;
    if (trafegoIdx === null) return;

    const raw = parseInt(trafegoDistancia, 10);
    const distancia = Number.isNaN(raw) ? 50 : Math.min(500, Math.max(30, raw));
    const ratio_limiar = this.normalizarRatioLimiar(trafegoIntensidade);

    const data = this.state.fases.slice();
    data[trafegoIdx] = {
      ...data[trafegoIdx],
      monitora_trafego: trafegoMonitora ? 1 : 0,
      distancia_trecho_m: distancia,
      ratio_limiar,
    };
    this.setState({ fases: data, showTrafego: false });

    if (this.props.onFasesChange) this.props.onFasesChange(data);

    const fase = data[trafegoIdx];
    const controladorIdCorreto =
      fase.controlador_id === 0 || !fase.controlador_id ? this.props['data-id'] : fase.controlador_id;
    if (fase.id && controladorIdCorreto) {
      this.props.update({ ...fase, controlador_id: controladorIdCorreto });
    }
  }

  renderButtonMap(cellInfo) {
    return (
      <span>
        <PermissaoUsuario tela="CadControlador" campo="localizacao_fase_mapa" condicao={true}>
          <SPButton
            type="button"
            className="success btn-sm"
            icon="map-marked-alt"
            data-title="Configurar Mapa"
            onClick={() => {
              this.clickMapaFase(cellInfo);
            }}
          />
        </PermissaoUsuario>
        <PermissaoUsuario tela="CadControlador" campo="localizacao_fase_mapa" condicao={false}>
          <SPButton
            type="button"
            className="success btn-sm"
            icon="map-marked-alt"
            data-title="Configurar Mapa"
            disabled="disabled"
          />
        </PermissaoUsuario>
      </span>
    );
  }

  renderAcoes(cellInfo) {
    const fase = this.state.fases[cellInfo.index];
    const temDescricao = fase && fase.descricao;
    const trafegoAtivo = fase && Number(fase.monitora_trafego) === 1;
    return (
      <span style={{ display: 'flex', gap: '2px', justifyContent: 'center', flexWrap: 'nowrap' }}>
        {this.renderButtonMap(cellInfo)}
        <SPButton
          type="button"
          className={temDescricao ? 'primary btn-sm' : 'default btn-sm'}
          icon="align-left"
          data-title={temDescricao ? fase.descricao : 'Adicionar descrição'}
          onClick={() => this.handleShowDescricao(cellInfo)}
        />
        {this.props.moduloAlertasTrafego && (
          <SPButton
            type="button"
            className={trafegoAtivo ? 'primary btn-sm' : 'default btn-sm'}
            icon="bell"
            data-title={this.resumoTrafego(fase)}
            onClick={() => this.handleShowTrafego(cellInfo)}
          />
        )}
      </span>
    );
  }

  componentWillMount() {
    this.setState({ fases: this.props['data-fases'] });
  }

  renderEditableAusencia(cellInfo) {
    return (
      <Select
        className="select-grid"
        contentEditable
        suppressContentEditableWarning
        onChange={event => {
          this.onChangeSelect(event, cellInfo);
        }}
        value={this.state.fases[cellInfo.index][cellInfo.column.id]}
        disabled={true}
      >
        <option value="1">Sim</option>
        <option value="0">Não</option>
      </Select>
    );
  }

  onChangeSelect(event, cellInfo) {
    const data = this.state.fases;

    if (data[cellInfo.index][cellInfo.column.id] != event.target.value) {
      data[cellInfo.index][cellInfo.column.id] = event.target.value;
      this.setState({ data });
    }
  }

  onChangeTipo(event, cellInfo) {
    const data = this.state.fases;

    if (data[cellInfo.index][cellInfo.column.id] != event.target.value) {
      data[cellInfo.index][cellInfo.column.id] = event.target.value;

      if (parseInt(event.target.value) === 1 && parseInt(data[cellInfo.index].quantidade) > 6) {
        data[cellInfo.index].quantidade = 1;
        data[cellInfo.index].quantidade_lat_lon = '';
      }

      this.setState({ data });
    }
  }

  onChangeQuantidade(event, cellInfo) {
    const data = this.state.fases;
    let pedestreLatLon = [];

    if (data[cellInfo.index][cellInfo.column.id] != event.target.value) {
      let valorDigitado = parseInt(event.target.value);

      data[cellInfo.index][cellInfo.column.id] = valorDigitado;

      for (let index = 0; index < valorDigitado; index++) {
        pedestreLatLon.push({
          latitude: data[cellInfo.index].latitude,
          longitude: data[cellInfo.index].longitude,
        });
      }
      data[cellInfo.index].quantidade_lat_lon = JSON.stringify(pedestreLatLon);

      this.setState({ data });
    }
  }

  renderEditablePiscante(cellInfo) {
    return (
      <Select
        className="select-grid"
        contentEditable
        suppressContentEditableWarning
        value={this.state.fases[cellInfo.index][cellInfo.column.id]}
        disabled={true}
      >
        <option value="5">Amarelo</option>
        <option value="4">Vermelho</option>
      </Select>
    );
  }

  renderEditablePiscantePedestre(cellInfo) {
    return (
      <Select
        cols="12"
        className="select-grid"
        contentEditable
        suppressContentEditableWarning
        onChange={event => {
          this.onChangeSelect(event, cellInfo);
        }}
        style={{ width: '100%' }}
        value={this.state.fases[cellInfo.index][cellInfo.column.id]}
        disabled={true}
      >
        <option value="5">Apagado</option>
        <option value="4">Vermelho</option>
      </Select>
    );
  }

  renderEditableTipo(cellInfo) {
    return (
      <Select
        className="select-grid"
        contentEditable
        suppressContentEditableWarning
        value={this.state.fases[cellInfo.index][cellInfo.column.id]}
        onChange={event => {
          this.onChangeTipo(event, cellInfo);
        }}
        disabled={true}
      >
        <option value="1">Veículo</option>
        <option value="2">Pedestre</option>
      </Select>
    );
  }

  renderEditableQuantidade(cellInfo) {
    let optionList = [];

    for (let index = 1; index <= 16; index++) {
      optionList.push(
        <option key={index} value={`${index}`}>
          {index}
        </option>,
      );

      if (index === 6 && parseInt(this.state.fases[cellInfo.index].tipo) === 1) break;
    }

    return (
      <span>
        <PermissaoUsuario tela="CadControlador" campo="localizacao_fase_mapa" condicao={false}>
          <Select
            className="select-grid"
            contentEditable
            suppressContentEditableWarning
            value={this.state.fases[cellInfo.index][cellInfo.column.id]}
            onChange={event => {
              this.onChangeQuantidade(event, cellInfo);
            }}
            disabled={true}
          >
            {optionList}
          </Select>
        </PermissaoUsuario>
        <PermissaoUsuario tela="CadControlador" campo="localizacao_fase_mapa" condicao={true}>
          <Select
            className="select-grid"
            contentEditable
            suppressContentEditableWarning
            value={this.state.fases[cellInfo.index][cellInfo.column.id]}
            onChange={event => {
              this.onChangeQuantidade(event, cellInfo);
            }}
          >
            {optionList}
          </Select>
        </PermissaoUsuario>
      </span>
    );
  }

  renderEditableMinimo(cellInfo) {
    let corFundo = '#f45555';
    switch (cellInfo.column.id) {
      case 'tempo_amarelo_min':
        corFundo = '#FFEB3B';
        break;
      case 'tempo_verde_min':
        corFundo = '#68BC00';
        break;
      default:
        corFundo = '#f45555';
        break;
    }

    return (
      <DivEditableGridNumeric
        contentEditable={false}
        inputMode={'numeric'}
        style={{ backgroundColor: corFundo }}
        dataType={'integer'}
        suppressContentEditableWarning
        id={`${cellInfo.column.id}_${cellInfo.index}`}
        value={this.state.fases[cellInfo.index][cellInfo.column.id]}
      />
    );
  }

  render() {
    const fase = this.state.fases || [];

    if (fase.length > 1) {
      const columns = [
        {
          Header: 'Ações',
          Cell: this.renderAcoes,
          className: 'column_icon',
          minWidth: 96,
          Filter: () => (
            <div className="rt-th">
              <span>Filtrar</span>
            </div>
          ),
        },
        {
          Header: 'Fase',
          accessor: 'id',
          className: 'column_grid column_center',
          minWidth: 55,
          Cell: ({ value }) => `Fase ${value}`,
        },
        {
          Header: 'Monit. Vermelho',
          accessor: 'ausencia_vermelho',
          className: 'column_grid column_select',
          Cell: this.renderEditableAusencia,
          minWidth: 100,
        },
        {
          Header: 'Cor Piscante',
          accessor: 'cor_piscante',
          className: 'column_grid column_select',
          Cell: this.renderEditablePiscante,
          minWidth: 120,
        },
      ];

      columns.push(
        {
          Header: 'Latitude',
          accessor: 'latitude',
          className: 'column_grid column_center',
          minWidth: 75,
        },
        {
          Header: 'Logitude',
          accessor: 'longitude',
          className: 'column_grid column_center',
          minWidth: 75,
        },
        {
          Header: 'Tipo',
          accessor: 'tipo',
          className: 'column_grid column_select',
          Cell: this.renderEditableTipo,
          minWidth: 112,
        },
        {
          Header: 'Quantidade',
          accessor: 'quantidade',
          className: 'column_grid column_select',
          Cell: this.renderEditableQuantidade,
          minWidth: 90,
        },

        {
          Header: 'T. mínimo',
          accessor: 'tempo_vermelho_min',
          className: 'column_grid column_center',
          Cell: this.renderEditableMinimo,
          minWidth: 80,
        },
        {
          Header: 'T. mínimo',
          accessor: 'tempo_amarelo_min',
          className: 'column_grid column_center',
          Cell: this.renderEditableMinimo,
          minWidth: 80,
        },
        {
          Header: 'T. mínimo',
          accessor: 'tempo_verde_min',
          className: 'column_grid column_center',
          Cell: this.renderEditableMinimo,
          minWidth: 80,
        },
      );

      return (
        <div>
          <ReactTableGT2A
            data={fase}
            columns={columns}
            defaultPageSize={fase.length}
            showPaginationBottom={true}
            showFilters={false}
            className="-highlight controlador-fases-react-table"
          />

          <Modal show={this.state.show} onHide={this.handleClose} dialogClassName="modal-mapa">
            <Modal.Body className="modal-body">{this.state.html}</Modal.Body>
            <Modal.Footer className="modal-header">
              <Button type="button" className="primary" icon="check" label="OK" onClick={this.clickOk} />
            </Modal.Footer>
          </Modal>

          <Modal show={this.state.showDescricao} onHide={this.handleCloseDescricao}>
            <Modal.Header>
              <Modal.Title>
                {this.state.descricaoIdx !== null && this.state.fases[this.state.descricaoIdx]
                  ? `Descrição — Fase ${this.state.fases[this.state.descricaoIdx].id}`
                  : 'Descrição da Fase'}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <label style={{ fontWeight: 600, marginBottom: 6, display: 'block' }}>Rua / Cruzamento:</label>
                <textarea
                  className="form-control"
                  rows={3}
                  maxLength={255}
                  placeholder="Ex: Rua XV de Novembro com Av. Brasil"
                  value={this.state.descricaoTexto}
                  onChange={e => this.setState({ descricaoTexto: e.target.value })}
                  style={{ resize: 'vertical' }}
                />
                <small className="text-muted" style={{ float: 'right' }}>
                  {this.state.descricaoTexto.length}/255
                </small>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                type="button"
                className="default"
                icon="times"
                label="Cancelar"
                onClick={this.handleCloseDescricao}
              />
              <Button
                type="button"
                className="primary"
                icon="check"
                label="Salvar"
                onClick={this.handleSaveDescricao}
              />
            </Modal.Footer>
          </Modal>

          <Modal show={this.state.showTrafego} onHide={this.handleCloseTrafego} dialogClassName="fase-trafego-modal">
            <Modal.Header closeButton>
              <div className="fase-trafego-modal__header-main">
                <div className="fase-trafego-modal__icon">
                  <i className="fa fa-bell" aria-hidden="true" />
                </div>
                <div>
                  <Modal.Title>Alertas de Tráfego</Modal.Title>
                  <span className="fase-trafego-modal__subtitle">
                    {this.state.trafegoIdx !== null && this.state.fases[this.state.trafegoIdx]
                      ? `Configuração da Fase ${this.state.fases[this.state.trafegoIdx].id}`
                      : 'Configuração da fase'}
                  </span>
                </div>
              </div>
            </Modal.Header>
            <Modal.Body>
              <div className="fase-trafego-modal__toggle-card">
                <label className="fase-trafego-modal__toggle">
                  <input
                    type="checkbox"
                    checked={this.state.trafegoMonitora}
                    onChange={e => this.setState({ trafegoMonitora: e.target.checked })}
                  />
                  <span className="fase-trafego-modal__switch" />
                  <span className="fase-trafego-modal__toggle-text">
                    <strong>Monitorar tráfego nesta fase</strong>
                    <small>Consulta o Google a cada 3 min e gera alerta quando o trânsito estiver intenso.</small>
                  </span>
                </label>
              </div>

              <div className={`fase-trafego-modal__settings${this.state.trafegoMonitora ? '' : ' is-disabled'}`}>
                <div className="fase-trafego-modal__field">
                  <label className="fase-trafego-modal__label" htmlFor="trafego-distancia-input">
                    Trecho de monitoramento
                  </label>
                  <div className="fase-trafego-modal__input-group">
                    <input
                      id="trafego-distancia-input"
                      type="number"
                      className="form-control"
                      min={30}
                      max={500}
                      step={10}
                      disabled={!this.state.trafegoMonitora}
                      value={this.state.trafegoDistancia}
                      onChange={e => this.setState({ trafegoDistancia: e.target.value })}
                    />
                    <span className="fase-trafego-modal__input-suffix">m</span>
                  </div>
                  <span className="fase-trafego-modal__hint">
                    Metros na via, a montante do pin, no sentido de quem se aproxima do cruzamento.
                  </span>
                </div>

                <div className="fase-trafego-modal__field">
                  <label className="fase-trafego-modal__label">Intensidade mínima para alerta</label>
                  <span className="fase-trafego-modal__hint fase-trafego-modal__hint--inline">
                    Cores equivalentes ao tráfego no Google Maps
                  </span>
                  <div className="fase-trafego-modal__intensity-list" role="radiogroup">
                    {INTENSIDADE_TRAFEGO_OPCOES.map(op => {
                      const selected = this.state.trafegoIntensidade === op.value;
                      return (
                        <label
                          key={op.value}
                          className={`fase-trafego-modal__intensity-option${selected ? ' is-selected' : ''}`}
                        >
                          <input
                            type="radio"
                            name="trafego-intensidade"
                            value={op.value}
                            checked={selected}
                            disabled={!this.state.trafegoMonitora}
                            onChange={e => this.setState({ trafegoIntensidade: e.target.value })}
                          />
                          <span
                            className="fase-trafego-modal__intensity-dot"
                            style={{ backgroundColor: op.mapsColor }}
                            title={op.label}
                          />
                          <span className="fase-trafego-modal__intensity-text">
                            <strong>{op.shortLabel}</strong>
                            <small>{op.hint}</small>
                          </span>
                        </label>
                      );
                    })}
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                type="button"
                className="default"
                icon="times"
                label="Cancelar"
                onClick={this.handleCloseTrafego}
              />
              <Button type="button" className="primary" icon="check" label="Salvar" onClick={this.handleSaveTrafego} />
            </Modal.Footer>
          </Modal>
        </div>
      );
    }

    return <div />;
  }
}

const mapStateToProps = state => ({
  moduloAlertasTrafego: !!(state.auth && state.auth.config && state.auth.config.modulo_alertas_trafego),
});
const mapDispatchToProps = dispatch => bindActionCreators({ update }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FaseList);
